import { all, call, put, select, takeLatest } from 'redux-saga/effects';

import SDK from 'utils/sdk';
import { format } from 'date-fns';
import { toast } from 'react-toastify';
import { financialReportGetLaborEfficiency } from './actions';
import { getFinancialReportFetchRange } from './selectors';

const getErrorMessage = (error, fallback) =>
  error?.response?.data?.message ||
  error?.response?.data?.error ||
  (typeof error === 'string' ? error : error?.message) ||
  fallback;

// The endpoint reports every studio the user can see, so the studio filter is
// applied client-side; only the period reaches the server. `startDate` and
// `endDate` must be month boundaries — the endpoint rejects anything else, and
// the controls only ever offer whole months.
function* getLaborEfficiencySaga() {
  try {
    const { startDate, endDate } = yield select(getFinancialReportFetchRange);
    if (!startDate || !endDate) {
      yield put(financialReportGetLaborEfficiency.fulfill());
      return;
    }
    yield put(financialReportGetLaborEfficiency.request());
    const client = yield call([SDK, 'getClient']);
    const { data } = yield call([client, 'getLaborEfficiency'], {
      startDate: format(new Date(startDate), 'yyyy-MM-dd'),
      endDate: format(new Date(endDate), 'yyyy-MM-dd'),
    });
    yield put(financialReportGetLaborEfficiency.success(data));
  } catch (error) {
    yield put(financialReportGetLaborEfficiency.failure(error));
    toast.error(getErrorMessage(error, 'Failed to load the financial report'));
  } finally {
    yield put(financialReportGetLaborEfficiency.fulfill());
  }
}

export default function* financialReportWatcher() {
  yield all([
    takeLatest(
      financialReportGetLaborEfficiency.TRIGGER,
      getLaborEfficiencySaga
    ),
  ]);
}
